import Intercom from "@intercom/messenger-js-sdk";

// Intercom web Messenger (chat bubble) for KonectX.
// App ID is baked in as a fallback; can be overridden via VITE_INTERCOM_APP_ID.
const APP_ID = (import.meta as unknown as { env: Record<string, string> }).env?.VITE_INTERCOM_APP_ID || "bhir0a40";

// NOTE: Booting WITHOUT user identity on purpose.
// Sending user_id/email without a signed verification token is what Intercom
// rejects with a 403 (the blank panel). Anonymous boot needs no token, so the
// Messenger loads. Identified + secure (JWT) users come back in step 2.
Intercom({ app_id: APP_ID });
